import { getUserAsyncResponse } from "./types";
import * as userActions from "./users.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiGet, API_URL_USER, retrieveToken } from "../../../helpers/api";

export function* getUsers() {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiGet, API_URL_USER.GET_USERS(1), token);
    if (result.status === 200) {
      const parsed: getUserAsyncResponse = yield call(result.json.bind(result));
      yield put(userActions.getUserAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userActions.getUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(userActions.getUserAsync.failure(parsed));
  }
}

export default function* usersSagaGetUser() {
  yield takeEvery(userActions.getUserAsync.request, getUsers);
}
